import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function SlipAndFall() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Slip and Fall Accidents</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
            <div className="pi-text">
                <p>Slip and fall accidents are one of the most common causes of personal injury and can happen
to anyone. While sometimes a slip and fall will not cause any personal injury, other times it can
lead to broken bones, sprains, head trauma, and disabilities. In some circumstances, deaths
can even occur.<br/><br/>
When you are on someone else’s property, they have a responsibility to ensure that conditions
are safe. There are many unsafe conditions that can lead to slip and fall accidents, including
things like wet floors or poor lighting. When you suffer a slip and fall due to unsafe conditions,
the owner of the property is liable.<br/><br/>
<span className="pi-sub-section">Types of Slip and Fall Personal Injury Cases We Handle</span><br/><br/>
As slip and fall injury lawyers, <b>CLV</b> handles a wide range of claims and cases. Slip and falls
are one of the leading causes of injuries, and they can actually result in a wide range of
impairments, disabilities, and complications. In some instances, a slip and fall may only result in
a minor injury, but other cases can cause disability or impairment.<br/>

Some of the slip and fall personal injury cases we handle include but are not limited to:
<ul>
 <li>Broken and fractured bones</li>
 <li>Spinal injuries</li>
 <li>Carpel tunnel syndrome</li>
 <li>Soft tissue injuries</li>
 <li>Back injuries</li>
 <li>Chronic pain injuries</li>
 <li>Migraines</li>
 <li>Sleep disorders</li>
<li>Internal organ injuries</li>
 <li>Traumatic brain injuries</li>
</ul><br/>
<span className="pi-sub-section">Compensation for Slip and Fall Injuries</span><br/><br/>
For people who have suffered injuries, <b>compensation for slip and fall injuries</b> can be
essential for covering expenses and loss of income, recovery, and resuming a more normal life.
A <Link to="/our-team/mick-vashishth">personal injury lawyer</Link> for slip and fall accidents can help their client receive the maximum
amount of slip and fall injury compensation they are entitled to, ensuring that they do not suffer
more than they already have.<br/><br/>
When a slip and fall accident has occurred, it is crucial to take the necessary steps following the
accident to ensure success with any legal claims. Strict deadlines and burdens of proof are
required for slip and fall claims. When someone is injured in a slip and fall, it is important to
immediately <b>contact a personal injury attorney</b> for slip and fall accidents. As well, injured
parties should report the accident immediately, take down contact information from witnesses,
take pictures of the scene of the accident, and seek medical attention.<br/><br/>
There are different types of compensation for slip and fall accidents that can be received,
including ones for:
<ul>
<li>Pain and suffering</li>
<li> Loss of income</li>
<li> Associated expenses (e.g. medication, rehabilitative expenses, travel costs, etc.)</li>
<li> Medical treatment</li>
<li> Future loss of income</li>
</ul>
Slip and Fall Claims and Premises Liability
There are many different factors that determine who is liable for an slip and fall injury you have
sustained and to how much compensation you are entitled. Your personal injury case may
change based on whether you sustained your injury on public property or private property in
Toronto. This is why you need a <b>personal injury lawyer</b> who can determine who is at fault and
can help you navigate the complexities of the legal process.
All it takes is one slip and fall to completely change your life. <b>CLV</b> has successfully represented
clients injured in slip and fall accidents and are equipped to handle complex legal and insurance
issues arising from your accident.
<br/><br/>
To arrange a Free consultation, <Link to="/contact-us">contact us</Link> today.</p>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
        </div>
            <Footer />
        </>
        );
}